export default __webpack_public_path__ + "static/media/Free.67b5fbbd.png";